import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { OnboardingV2State } from '../../../../store/onboardingV2/types.ts';
import { useHorizontalDragScroll } from '../../../../hooks/onboardingV2/useHorizontalDragScroll.ts';
import styles from './ProfilesSelector.module.scss';

interface ProfilesSelectorProps {
  state: OnboardingV2State;
  onAction: (action: string, data?: any) => void;
}

const ProfilesSelector: React.FC<ProfilesSelectorProps> = ({ state, onAction }) => {
  const skillCategories = useMemo(() => {
    return state.skillCategories || [];
  }, [state.skillCategories]);

  const categoryScroll = useHorizontalDragScroll([
    state.preferredProfileCategories.length,
    skillCategories.length,
  ]);

  return (
    <motion.div
      className={styles.interactiveContainer}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className={styles.profilesSection}>
        <div className={styles.profilesHeader}>
          <span className={styles.profilesTitle}>
            Seleccioná con qué perfiles querés conectar
          </span>
          {state.preferredProfileCategories.length > 0 && (
            <motion.button
              className={`${styles.skillsContinueButton} ${styles.profilesContinueButton}`}
              onClick={() => onAction('profilesComplete')}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="button"
            >
              Continuar
            </motion.button>
          )}
        </div>
        <div
          className={styles.categoryFilters}
          ref={categoryScroll.ref}
          onMouseDown={categoryScroll.onMouseDown}
          onMouseMove={categoryScroll.onMouseMove}
          onMouseUp={categoryScroll.onMouseUp}
          onMouseLeave={categoryScroll.onMouseLeave}
        >
          {skillCategories.map((category) => (
            <motion.button
              key={category.id}
              className={`${styles.categoryPill} ${
                state.preferredProfileCategories.includes(category.id) ? styles.active : ''
              }`}
              onClick={() => onAction('profileCategory', { categoryId: category.id })}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="button"
            >
              {state.preferredProfileCategories.includes(category.id) && (
                <Check size={16} className={styles.selectedCheck} />
              )}
              {category.name}
            </motion.button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default ProfilesSelector;
